import { type ComponentProps } from "react";

import { cn } from "../../utils";

export const Item = ({ ref, className, ...props }: ComponentProps<"li">) => (
  <li
    ref={ref}
    className={cn("shrink-0 text-sm font-semibold text-neutral-50 hover:text-neutral-30", className)}
    {...props}
  />
);
Item.displayName = "BreadcrumbItem";

export default Item;
